export const getDocumentNumber = (invoice) => {
  if (!invoice) return "";
  if (invoice.OfferPrice === true || invoice.OfferPrice === 1 || invoice.OfferPrice === "true") {
    return invoice.po_document_number;
  }
  if (invoice.salesReturn === true || invoice.salesReturn === 1 || invoice.salesReturn === "true" || invoice.original_invoice_id) {
    return invoice.sr_document_number;
  }
  return invoice.i_document_number;
};

export const getDocumentId = (invoice) => {
  const number = getDocumentNumber(invoice);
  if (number === null || number === undefined || number === "") return "";
  const isSalesReturn = invoice?.salesReturn === true || invoice?.salesReturn === 1 || invoice?.salesReturn === "true" || invoice?.original_invoice_id;
  return isSalesReturn ? `RET-${number}` : String(number);
};
